export default __webpack_public_path__ + "static/css/error.min.css";